import React from 'react';
import { withTheme } from '../core/theming';

import Div from './Div';

/* eslint-disable react/prop-types */

const Container = ({ p, m, theme, ...rest }) => (
	<Div w="100%" m={{ y: 0, x: 'auto' }} p={{ y: 0, x: '16px' }} maxW={theme.grid.containerMaxWidth} {...rest} />
);

/* eslint-enable react/prop-types */

export default withTheme(Container);
